import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import des traductions
import enCommon from './locales/en/common.json'
import frCommon from './locales/fr/common.json'
import deCommon from './locales/de/common.json'
import esCommon from './locales/es/common.json'
import itCommon from './locales/it/common.json'

const resources = {
  en: {
    common: enCommon
  },
  fr: {
    common: frCommon
  },
  de: {
    common: deCommon
  },
  es: {
    common: esCommon
  },
  it: {
    common: itCommon
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    // Configuration du détecteur de langue
    detection: {
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupQuerystring: 'lng',
      lookupLocalStorage: 'i18nextLng'
    },

    // Namespace par défaut
    defaultNS: 'common',
    ns: ['common'],

    interpolation: {
      escapeValue: false // React échappe déjà les valeurs
    },

    // Langues supportées
    supportedLngs: ['en', 'fr', 'de', 'es', 'it'],
    nonExplicitSupportedLngs: true
  })

export default i18n
